'use client'

import { useEffect } from 'react'
import { useNavigate } from '@tanstack/react-router'
import { createClient } from '@/utils/supabase/client'

export function InviteRedirect() {
  const navigate = useNavigate()

  useEffect(() => {
    const checkAndRedirect = async () => {
      const supabase = createClient()
      const { data: { user } } = await supabase.auth.getUser()

      if (user?.user_metadata?.needs_password_change) {
        void navigate({ to: '/setup-password' })
      }
    }

    checkAndRedirect()
  }, [navigate])

  return null
}